export default "__VITE_ASSET__OZh8TLd4__"